module.exports = __webpack_public_path__ + "media/images/default/pages/shared/34436-c506f7492fc45a985b07b9113f55ddf1.jpeg";